function alertmessg (idd){
    var title = $('.product-converter__title div h1').text().trim();
    $('.product-converter__error[data-id="'+idd+'"]').html(`<span class="icon loaded">error</span><p>Je kunt geen ${title} meer aan je winkelwagen toevoegen.</p>`)
}

function get_cart(idd, callback) {
    $.getJSON('/cart', function (cart) {
        var items = cart.items;
        var find = items.find(x => x.id == idd);

        if (find) {
            callback(find.quantity); 
        } else {
            callback(null); 
        }
    });
}

let isProcessing = false; 

function add_disable(total, idd, btn) {
    if (isProcessing) return;
    isProcessing = true;

    total = Number(total);
    const inn = $('.product-converter__content .quantity input , .sticky-add-to-cart__controls.data_matches .quantity input');
    let m = parseInt(inn.val());

    if (btn === 'plus') {
        get_cart(idd, function(quantity) {
            if (quantity !== null) {
                const cart_qty = quantity;
                const add = cart_qty + m;
                const remaining = total - cart_qty;

                if (add >= total) {
                    alertmessg(idd);
                    $('.data_matches[data-id="' + idd + '"] button[name="plus"]').addClass('disable');
                    inn.val(remaining);
                    $('input#quantity').each(function() {
                        $(this).val(remaining);
                    });
                } else {
                    $('.data_matches[data-id="' + idd + '"] button[name="plus"]').removeClass('disable');
                    const newVal = m + 1;
                    inn.val(newVal);
                    $('input#quantity').each(function() {
                        $(this).val(newVal);
                    });
                }
            } else {
                if (m >= total) {
                    alertmessg(idd);
                    inn.val(total);
                    $('input#quantity').each(function() {
                        $(this).val(total);
                    });
                    $('.data_matches[data-id="' + idd + '"] button[name="plus"]').addClass('disable');
                } else {
                    const newVal = m + 1;
                    inn.val(newVal);
                    $('input#quantity').each(function() {
                        $(this).val(newVal);
                    });
                    $('.data_matches[data-id="' + idd + '"] button[name="plus"]').removeClass('disable');
                }
            }
            isProcessing = false; // Unlock after processing
        });
    } else {
        if (m > 1) {
            $('.data_matches[data-id="' + idd + '"] button[name="plus"]').removeClass('disable');
            const newVal = m - 1;
            inn.val(newVal);
            $('input#quantity').each(function() {
                $(this).val(newVal);
            });
            $('.product-converter__error[data-id="'+idd+'"]').html('');
        }
        isProcessing = false; // Unlock for other operations
    }
}


!(function () {
    const t = document.querySelectorAll(".product-converter__content"),
        e = document.querySelector(".sticky-add-to-cart");
    var ee =  t[0].querySelector('.data_matches');
    var idd = ee.getAttribute('data-id');
    var total = ee.getAttribute('data-qty');
  
    let u = null,
        n = null;
    t.forEach((t) => {
        (u = t.querySelector('button[name="plus"]')), (n = t.querySelector('button[name="minus"]')), e && ((qtyPlusSticky = e.querySelector('button[name="plus"]')), (qtyMinusSticky = e.querySelector('button[name="minus"]')));
        const c = (u) => {
            (t.querySelector(".quantity input").value = u), (t.querySelector("#quantity").value = u), e && ((e.querySelector(".quantity input").value = u), (e.querySelector("#quantity").value = u));
        };
        if (t.querySelector(".quantity input") && t.querySelector("#quantity")) {
            let i = parseInt(t.querySelector("#quantity").value);
            u.addEventListener("click",function () {
            var btn = u.getAttribute('name');
            // (i += 1), c(i);
            add_disable(total, idd, btn);
            }),
            n.addEventListener("click",function () {
            var btn = n.getAttribute('name');
            add_disable(total, idd, btn);
                    // i > 1 && ((i -= 1), c(i));
                }),
                e &&
                    qtyPlusSticky &&
                    qtyMinusSticky &&
                    (qtyPlusSticky.addEventListener("click", function () {
                    var btn = qtyPlusSticky.getAttribute('name');
                        // (i += 1), c(i);
                    var input = e.querySelector(".quantity input").value;
                    add_disable(total, idd, btn);
                    }),
                    qtyMinusSticky.addEventListener("click", function () {
                      var btn = qtyMinusSticky.getAttribute('name');
                        // i > 1 && ((i -= 1), c(i));
                       add_disable(total, idd, btn);
                    }));
        }
    });
})();


                // $('.data_matches[data-id="'+idd+'"] button[name="plus"]').removeClass('disable');
